import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { showcaseMessages } from './showcaseMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the showcase parts; each part uses its own slice of it */
import styles from './MusicVideoShowcase.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The showcase bank search over its limit (design c4, 429 `M24_RATE_LIMITED`): one amber line in
 * place of the results. No toast and no dialog; the clips of the cut still play and drag.
 */
const ShowcaseSearchBusyComponent: React.FC = () => {
  const intl = useIntl();
  return (
    <div className={styles.busy} role="status">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </svg>
      <div>{intl.formatMessage(showcaseMessages.searchBusy)}</div>
    </div>
  );
};

export const ShowcaseSearchBusy = TypedMemo(ShowcaseSearchBusyComponent);
